import React from 'react';
import { TextInput } from 'apps/sigma2-ui/src/components/ui/TextInput';
import classNames from 'classnames';

export const SimpleInput = (props: {
  label: string;
  value: string;
  disabled?: boolean;
  onChange: (newValue: string) => void;
  isPassword?: boolean;
  extrasClassName?: string;
  placeholder?: string;
}) => {
  const { label, value, disabled, onChange, extrasClassName, placeholder } =
    props;

  return (
    <>
      {label}{' '}
      <TextInput
        className={classNames(
          `border border-gray-400 rounded-md px-2 py-1`,
          extrasClassName,
          {
            'bg-gray-200': disabled ?? false,
          },
        )}
        data-qa={`${label}Input`}
        value={value}
        placeholder={placeholder}
        type={props.isPassword ? 'password' : 'text'}
        onChange={(e) => onChange(e.currentTarget.value)}
        disabled={disabled}
      />
    </>
  );
};
